export const darkTheme = {
  // appbg: "#575757",
  appbg: "#1B1B1D",
  cardbg: "#1E1E1E",
  textprimary: "#FFFFFF",
  textsecondary: "#94A3B8",
  bordercolor: "#2D2D2D",
  actionitembg: "#262626",
  dashboardbg: "#121212",
  primaryaccent: "#FF4D4F",
  secondaryaccent: "#2B2B2D",
  accentborder: "#363638",
  breadcrumbactive: "#FFFFFF",
  breadcrumbinactive: "#A0A0A2",
  sectionheaderbg: "#1E1E1E",
  tabletext: "#FFFFFF",
  statussuccessbg: "#064E3B",
  statussuccesstext: "#34D399",
  statuspendingbg: "#78350F",
  statuspendingtext: "#FBBF24",
  statusactionbg: "#1E3A8A",
  statusactiontext: "#93C5FD",
  statusactionbtn: "#10B981",
  statussignbtn: "#EF4444",
  statuserrorbg: "#7F1D1D",
  statuserrortext: "#FCA5A5"
};

export const lightTheme = {
  appbg: "#FFEFEF",
  cardbg: "#FFFFFF",
  textprimary: "#0F172A",
  textsecondary: "#64748B",
  bordercolor: "#F1F5F9",
  actionitembg: "#F2FAFF",
  dashboardbg: "#FFFFFF",
  primaryaccent: "#E31F26",
  secondaryaccent: "#FFEFEF",
  accentborder: "transparent",
  breadcrumbactive: "#1E293B",
  breadcrumbinactive: "#64748B",
  sectionheaderbg: "#F8FAFC",
  tabletext: "#1E293B",
  statussuccessbg: "#F0FDF4",
  statussuccesstext: "#166534",
  statuspendingbg: "#FEF3C7",
  statuspendingtext: "#92400E",
  statusactionbg: "#F8FAFC",
  statusactiontext: "#1E3A8A",
  statusactionbtn: "#10B981",
  statussignbtn: "#DC2626",
  statuserrorbg: "#FEF2F2",
  statuserrortext: "#991B1B"
};
